import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'tests',
    lazy: async () => ({ Component: (await import('./TestsPage')).TestsPage }),
  },
];
